import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const DemoSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="demo" className="px-4 sm:px-6 py-12 sm:py-16 bg-card/50" aria-labelledby="demo-heading" ref={ref}>
      <div className="max-w-4xl mx-auto text-center">
        <motion.div 
          className="mb-8"
          variants={staggerContainer}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.h2 
            id="demo-heading" 
            className="text-3xl sm:text-4xl font-bold text-foreground mb-4"
            variants={fadeInUp}
          >
            See YakStak in action
          </motion.h2>
          <motion.p 
            className="text-lg text-foreground max-w-2xl mx-auto"
            variants={fadeInUp}
          >
            Watch how YakStak transforms your user interview notes into clear insights and actionable product decisions
          </motion.p>
        </motion.div>
        
        <motion.div 
          className="relative w-full max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <div className="relative w-full bg-card rounded-xl shadow-xl overflow-hidden">
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src="https://www.loom.com/embed/4702f6b05b1b4e0aa966a0469b8dc3dd?sid=de9390ec-e6f6-474c-a6e6-20cd8a3a09dc"
                frameBorder="0"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
                title="YakStak Demo - Transform User Interviews into Product Insights"
                loading="lazy"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};